import { defineMessages } from 'react-intl';

export const productBaseInfoMessages = defineMessages({
  tryItOnButton: {
    id: 'pd.tryItOnButton',
    defaultMessage: 'Zkusit na sobě',
  },
  similarProductsButton: {
    id: 'product.similarProductsButton',
    defaultMessage: 'Podobné produkty',
  },
});
